const actions = {
  GET_CLIENT_SECRET_BEGIN: 'GET_CLIENT_SECRET_BEGIN',
  GET_CLIENT_SECRET_SUCCESS: 'GET_CLIENT_SECRET_SUCCESS',
  GET_CLIENT_SECRET_ERR: 'GET_CLIENT_SECRET_ERR',

  DELETE_CARD_BEGIN: 'DELETE_CARD_BEGIN',
  DELETE_CARD_SUCCESS: 'DELETE_CARD_SUCCESS',
  DELETE_CARD_ERR: 'DELETE_CARD_ERR',

  GET_CUSTOMER_CARD_BEGIN: 'GET_CUSTOMER_CARD_BEGIN',
  GET_CUSTOMER_CARD_SUCCESS: 'GET_CUSTOMER_CARD_SUCCESS',
  GET_CUSTOMER_CARD_ERR: 'GET_CUSTOMER_CARD_ERR',

  SET_DEFAULT_CARD_BEGIN: 'SET_DEFAULT_CARD_BEGIN',
  SET_DEFAULT_CARD_SUCCESS: 'SET_DEFAULT_CARD_SUCCESS',
  SET_DEFAULT_CARD_ERR: 'SET_DEFAULT_CARD_ERR',

  getClientSecretBegin: () => {
    return {
      type: actions.GET_CLIENT_SECRET_BEGIN,
    };
  },
  getClientSecretSuccess: (data) => {
    return {
      type: actions.GET_CLIENT_SECRET_SUCCESS,
      data,
    };
  },
  getClientSecretErr: (err) => {
    return {
      type: actions.GET_CLIENT_SECRET_ERR,
      err,
    };
  },
  deleteCardBegin: () => {
    return {
      type: actions.DELETE_CARD_BEGIN,
    };
  },
  deleteCardSuccess: (data) => {
    return {
      type: actions.DELETE_CARD_SUCCESS,
      data,
    };
  },
  deleteCardErr: (err) => {
    return {
      type: actions.DELETE_CARD_ERR,
      err,
    };
  },
  getCustomerCardsBegin: () => {
    return {
      type: actions.GET_CUSTOMER_CARD_BEGIN,
    };
  },
  getCustomerCardsSuccess: (data) => {
    return {
      type: actions.GET_CUSTOMER_CARD_SUCCESS,
      data,
    };
  },
  getCustomerCardsErr: (err) => {
    return {
      type: actions.GET_CUSTOMER_CARD_ERR,
      err,
    };
  },
  setDefaultCardBegin: () => {
    return {
      type: actions.SET_DEFAULT_CARD_BEGIN,
    };
  },
  setDefaultCardSuccess: (data) => {
    return {
      type: actions.SET_DEFAULT_CARD_SUCCESS,
      data,
    };
  },
  setDefaultCardErr: (err) => {
    return {
      type: actions.SET_DEFAULT_CARD_ERR,
      err,
    };
  },
};
export default actions;
